import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from './posts';
import Seo from '../../components/seo/Seo';
import { breadcrumbSchema, SITE_URL } from '../../components/seo/jsonld';
import GoogleAd from '../../components/GoogleAd';
import { AD_SLOTS } from '../../components/adSlots';

const blogListSchema = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    url: `${SITE_URL}/blog`,
    name: 'pdfconvertor.shop Blog',
    blogPost: posts.map((p) => ({
        '@type': 'BlogPosting',
        headline: p.title.replace(/&[a-z]+;/g, "'"),
        url: `${SITE_URL}/blog/${p.slug}`,
        datePublished: p.date,
        description: p.description,
    })),
};

const BlogIndexPage = () => (
    <>
        <Seo
            title="Blog — Guides & How-Tos on PDF Conversion"
            description="Practical, honest guides on converting, compressing, and securing PDFs. Written for people who actually need to ship documents, not theorize about them."
            path="/blog"
            jsonLd={[
                blogListSchema,
                breadcrumbSchema([
                    { name: 'Home', path: '/' },
                    { name: 'Blog', path: '/blog' },
                ]),
            ]}
        />

        <div className="page-container narrow">
            <header className="page-header">
                <h1>Blog</h1>
                <p className="page-lead">
                    Honest, practical writing on document conversion, PDF security, and getting
                    work done without handing your files to unknown servers.
                </p>
            </header>

            <GoogleAd slot={AD_SLOTS.BLOG_INDEX} className="ad-slot-inline" />

            <section className="blog-list">
                {posts.map((p) => (
                    <article key={p.slug} className="blog-list-item">
                        <p className="blog-post-meta">
                            <time dateTime={p.date}>
                                {new Date(p.date).toLocaleDateString(undefined, {
                                    year: 'numeric', month: 'long', day: 'numeric',
                                })}
                            </time>
                            <span aria-hidden="true"> &middot; </span>
                            <span>{p.readingTime}</span>
                        </p>
                        <h2>
                            <Link to={`/blog/${p.slug}`}>
                                <span dangerouslySetInnerHTML={{ __html: p.title }} />
                            </Link>
                        </h2>
                        <p>{p.excerpt}</p>
                        <p>
                            <Link to={`/blog/${p.slug}`} className="blog-read-more">
                                Read more &rarr;
                            </Link>
                        </p>
                    </article>
                ))}
            </section>
        </div>
    </>
);

export default BlogIndexPage;
